import useCbIntl from './useCbIntl';

export default useCbIntl;